module.exports = __webpack_public_path__ + "static/media/vent_termostat.f63b93aa.pdf";